<template>
  <article class="contact-search-card" @click="emailClick(email, emailTeam)">
    <div class="contact-search-card__body">
      <component :is="headingTag" class="contact-search-card__title">{{ name }}</component>

      <ul class="contact-search-card__contact-list" role="list">
        <li v-if="position">
          <i class="fal fa-badge fa-fw" aria-label="Position"></i> {{ position }}
        </li>
        <li v-if="phone">
          <i class="fal fa-phone fa-fw" aria-label="Phone"></i>
          <a :href="'tel:' + phone">{{ phone }}</a>
        </li>
        <li v-if="mobile">
          <i class="fal fa-mobile-android fa-fw" aria-label="Mobile"></i>
          <a :href="'tel:' + mobile">{{ mobile }}</a>
        </li>
        <li v-if="email">
          <i class="fal fa-envelope fa-fw" aria-label="Email address"></i>
          <a :href="mailToHref" :class="{
            'cryptedmail': !displayMail
          }" :data-name="emailSplit.name" :data-domain="emailSplit.domain" :data-tld="emailSplit.tld">
            {{ displayMail }}
          </a>
        </li>
        <li v-if="emailTeam">
          <i class="fal fa-envelope fa-fw" aria-label="Email address (team)"></i>
          <a :href="teamMailToHref" :class="{
            'cryptedmail': !displayTeamMail
          }" :data-name="emailTeamSplit.name" :data-domain="emailTeamSplit.domain" :data-tld="emailTeamSplit.tld">
            {{ displayTeamMail }}
          </a>
        </li>
        <li v-if="vcard">
          <i class="fal fa-address-card fa-fw" aria-hidden="true"></i>
          <a :href="vcard">Download vCard</a>
        </li>
      </ul>
    </div>
  </article>
</template>

<script>
export default {
  name: 'ContactSearchEmployeeCard',

  props: {
    name: {
      type: String,
      required: true,
    },
    position: {
      type: [String, null],
      default: null,
    },
    phone: {
      type: [String, null],
      default: null,
    },
    mobile: {
      type: [String, null],
      default: null,
    },
    email: {
      type: [String, null],
      default: null,
    },
    emailSplit: {
      type: [Object, null],
      default: null,
    },
    emailTeam: {
      type: [String, null],
      default: null,
    },
    emailTeamSplit: {
      type: [Object, null],
      default: null,
    },
    vcard: {
      type: [String, null],
      default: null,
    },
    headingTag: {
      type: String,
      default: 'h3',
    }
  },

  data() {
    return {
      mailToHref: '#',
      displayMail: null,
      teamMailToHref: '#',
      displayTeamMail: null,
    }
  },

  methods: {
    emailClick(email, emailTeam) {
      this.mailToHref = 'mailto:' + email.email;
      this.displayMail = email.email;
      this.teamMailToHref = 'mailto:' + emailTeam.emailTeam;
      this.displayTeamMail = emailTeam.emailTeam;
    },
  },

}
</script>

<style>
.cryptedmail:after {
  content: attr(data-name) "@" attr(data-domain) "." attr(data-tld);
}
</style>
